import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useState } from 'react';

// How much of each end fades out while there's more to scroll to there.
const FADE = '1.5rem';

/**
 * Which ends of a scroll box have more to scroll to, and a mask that fades them, so a reader can tell the list goes on.
 */
const useScrollFade = (boxRef, contentRef) => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      start: false,
      end: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [overflow, setOverflow] = useState(t0);
  let t1;
  if ($[1] !== boxRef) {
    t1 = () => {
      const box = boxRef.current;
      if (!box) {
        return;
      }
      const start = box.scrollTop > 0;
      const end = box.scrollTop + box.clientHeight < box.scrollHeight - 1;
      setOverflow(prev => prev.start === start && prev.end === end ? prev : {
        start,
        end
      });
    };
    $[1] = boxRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const check = t1;
  let t2;
  if ($[3] !== boxRef || $[4] !== check || $[5] !== contentRef) {
    t2 = () => {
      const observer = new ResizeObserver(check);
      for (const element of [boxRef.current, contentRef.current]) {
        if (element) {
          observer.observe(element);
        }
      }
      return () => observer.disconnect();
    };
    $[3] = boxRef;
    $[4] = check;
    $[5] = contentRef;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  const maskImage = overflow.start || overflow.end ? `linear-gradient(to bottom, ${overflow.start ? "transparent" : "#000"}, #000 ${FADE}, #000 calc(100% - ${FADE}), ${overflow.end ? "transparent" : "#000"})` : undefined;
  let t4;
  if ($[8] !== check || $[9] !== maskImage || $[10] !== overflow) {
    t4 = {
      overflow,
      maskImage,
      onScroll: check
    };
    $[8] = check;
    $[9] = maskImage;
    $[10] = overflow;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default useScrollFade;